import React from 'react';
import styled from 'styled-components';
import { vieurekaOrange, white } from 'constants/colors';
import { useLoading } from './hooks';

const Loading: React.FC = () => {
  const { loading } = useLoading();

  return (
    <LoadingBackdrop $_loading={loading}>
      <LoadingContainer $_loading={loading}>
        <LoadingSpinner $spinnerColor={vieurekaOrange} $startRadius={'55%'} />
      </LoadingContainer>
    </LoadingBackdrop>
  );
};

type LoadingBackdropProps = {
  $_loading: boolean;
};
const LoadingBackdrop = styled.div<LoadingBackdropProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ $_loading }) =>
    $_loading ? 'rgba(0, 0, 0, 0.5)' : 'transparent'};
  visibility: ${({ $_loading }) => ($_loading ? 'visible' : 'hidden')};
  transition: all 0.1s ease;
`;

const LoadingContainer = styled.div<{ $_loading: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 140px;
  background-color: ${white};
  border-radius: 8px;
  opacity: ${({ $_loading }) => ($_loading ? '1' : '0')};
  transition: opacity 0.1s ease;
`;

type LoadingStyledProps = {
  $spinnerColor: string;
  $startRadius: string;
};
const LoadingSpinner = styled.div<LoadingStyledProps>`
  --spinner-color: ${({ $spinnerColor }) => $spinnerColor};
  --start-radius: ${({ $startRadius }) => $startRadius};
  --end-radius: 70%;

  width: 34px;
  height: 34px;
  background-image: radial-gradient(
    transparent,
    transparent calc(var(--start-radius) - 1px),
    var(--spinner-color) var(--start-radius),
    var(--spinner-color) calc(var(--end-radius) - 1px),
    transparent var(--end-radius)
  );
  transform: rotate(0deg);
  animation: loading-clip 1s linear 0s infinite,
    loading-spin 0.6s linear 0s infinite;
  clip-path: none;

  @keyframes loading-clip {
    from {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 50% 0, 50% 0, 50% 0);
    }

    12.5% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 0, 100% 0);
    }

    25% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 50%, 100% 50%);
    }

    37.5% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 100%, 100% 100%);
    }

    50% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 100%, 50% 100%);
    }

    62.5% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 100%, 100% 100%);
    }

    75% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 50%, 100% 50%);
    }

    87.5% {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 100% 0, 100% 0, 100% 0);
    }

    to {
      clip-path: polygon(50% 50%, 0 50%, 0 0, 50% 0, 50% 0, 50% 0);
    }
  }

  @keyframes loading-spin {
    from {
      transform: rotate(0deg);
    }

    from {
      transform: rotate(360deg);
    }
  }
`;

export default Loading;
